import React, { useState } from 'react';
import Container from '../components/misc/Container';
import LayoutHomepage from '../layout/LayoutHomepage';
import LogoLinkAja from '../assets/logo/link-aja.svg';
import LogoDana from '../assets/logo/dana.svg';
import LogoOvo from '../assets/logo/ovo.svg';
import Brokoli from '../assets/images/brokoli.png';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import JagungManis from '../assets/images/sayur/buah/jagung.jpeg';
import Kentank from '../assets/images/sayur/umbi/kentang.jpeg';
import Selada from '../assets/images/sayur/daun/selada.jpeg';
import PaprikaMerah from '../assets/images/sayur/buah/paprika-merah.jpeg';
import ModalAddress from '../components/Checkout/ModalAddress';
import ModalConfirmAddress from '../components/Checkout/ModalConfirmAddress';
import ModalTimeSend from '../components/Checkout/ModalTimeSend';
import ModalPayment from '../components/Checkout/ModalPayment';
import ModalHowToTransfer from '../components/Checkout/ModalHowToTransfer';

const Checkout = () => {
  const [showModalAddress, setShowModalAddress] = useState(false);
  const [showModalConfirmAddress, setShowModalConfirmAddress] = useState(false);
  const [showModalTime, setShowModalTime] = useState(false);
  const [showModalPayment, setShowModalPayment] = useState(false);
  const [showModalHowToTransfer, setShowModalHowToTransfer] = useState(false);

  return (
    <LayoutHomepage>
      {showModalAddress && (
        <ModalAddress
          handdleCloseModal={() => setShowModalAddress(!showModalAddress)}
          handdleClick={() => {
            setShowModalAddress(!showModalAddress);
            setShowModalConfirmAddress(!showModalConfirmAddress);
          }}
        />
      )}
      {showModalTime && (
        <ModalTimeSend
          handdleCloseModal={() => setShowModalTime(!showModalTime)}
          handdleClickConfirm={() => {
            setShowModalTime(!showModalTime);
          }}
        />
      )}
      {showModalPayment && (
        <ModalPayment
          handdleCloseModal={() => setShowModalPayment(!showModalPayment)}
          handdleClickConfirm={() => {
            setShowModalPayment(!showModalPayment);
          }}
          handdleHowToTransfer={() => {
            setShowModalPayment(!showModalPayment);
            setShowModalHowToTransfer(!showModalHowToTransfer);
          }}
        />
      )}
      {showModalHowToTransfer && (
        <ModalHowToTransfer
          handdleCloseModal={() =>
            setShowModalHowToTransfer(!showModalHowToTransfer)
          }
          handdleClickConfirm={() =>
            setShowModalHowToTransfer(!showModalHowToTransfer)
          }
        />
      )}
      {showModalConfirmAddress && (
        <ModalConfirmAddress
          handdleCloseModal={() =>
            setShowModalConfirmAddress(!showModalConfirmAddress)
          }
          handdleClickConfirm={() =>
            setShowModalConfirmAddress(!showModalConfirmAddress)
          }
          handdleClickBack={() => {
            setShowModalAddress(!showModalAddress);
            setShowModalConfirmAddress(!showModalConfirmAddress);
          }}
        />
      )}
      {}
      <Container>
        <form className="flex my-8 bg-white rounded min-h-screen w-full mt-40">
          <div className="flex flex-col w-6/12 px-8 py-4">
            <h1 className="text-font-gray mb-4 text-2xl">Ringkasan Belanja</h1>
            <div className="flex flex-col mt-2">
              <p className="text-font-gray opacity-50 mb-2">
                Alamat Pengiriman
              </p>
              <div className="flex flex-col">
                <div
                  className="flex border border-gray-400 rounded-t py-4 pl-8 pr-4 bg-white cursor-pointer"
                  onClick={(e) => {
                    setShowModalAddress(!showModalAddress);
                  }}
                >
                  <p className="text-font-gray max-w-xs w-10/12">
                    Jl. Borobudur No.27A, Mojolangu, Kec. Lowokwaru, Kota Malang
                    Jawa Timur 65142, Indonesia
                  </p>
                  <svg
                    className="w-6 h-6 ml-auto my-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
                <div className="bg-gray-200 py-4 px-6">
                  <label className="block bg-gray-200 rounded-md">
                    <input
                      type="text"
                      className="focus:outline-none form-input mt-1 block w-full text-font-gray bg-gray-200 border-none rounded-bl-lg rounded-br-lg"
                      placeholder="Isi detail alamat pengantaran"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="flex flex-col mt-6">
              <p className="text-font-gray opacity-50 mb-2">
                Pilih Waktu Pengiriman
              </p>
              <div className="flex flex-col">
                <div
                  className="flex border border-gray-400 rounded-t py-4 pl-8 pr-4 bg-white cursor-pointer"
                  onClick={() => {
                    setShowModalTime(!showModalTime);
                  }}
                >
                  <div className="flex flex-col max-w-xs w-10/12 text-font-gray">
                    <p>Besok, 17 Agu 2020 </p>
                    <p>08.00-09.00</p>
                  </div>
                  <svg
                    className="w-6 h-6 ml-auto my-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
            <div className="flex flex-col mt-6">
              <p className="text-font-gray opacity-50 mb-2">Penerima</p>
              <div className="flex flex-col">
                <div className="bg-gray-200 pt-4 pb-1 px-6">
                  <label className="block bg-white ">
                    <input
                      type="text"
                      className="focus:outline-none form-input mt-1 block w-full text-font-gray bg-gray-200 border-none rounded-bl-lg"
                      placeholder="Isi Nama"
                    />
                  </label>
                </div>
                <hr />
                <div className="bg-gray-200 pb-4 pt-1 px-6">
                  <label className="block bg-white ">
                    <input
                      type="text"
                      className="focus:outline-none form-input mt-1 block w-full text-font-gray bg-gray-200 border-none rounded-bl-lg"
                      placeholder="Isi Nomor Hp"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="flex flex-col mt-6">
              <p className="text-font-gray opacity-50 mb-2">Kode Promo</p>
              <div className="flex flex-col">
                <div className="bg-gray-200 py-4 px-6">
                  <label className="block bg-white ">
                    <input
                      type="text"
                      className="bg-gray-200 form-input mt-1 block w-full text-font-gray outline-none border-none focus:placeholder-opacity-0"
                      placeholder="Isi Nama"
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col  ml-auto w-4/12 pl-8 pr-6 py-8 ">
            <div className="flex flex-col mt-6">
              <p className="text-font-gray  capitalize opacity-50 mb-2">
                Pembayaran Melalui
              </p>
              <div className="flex flex-col">
                <button
                  className="pl-8 pr-6 py-5 border border-gray-400 hover:border-orange-500 flex items-center rounded"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModalPayment(!showModalPayment);
                  }}
                >
                  <p>Pilih Pembayaran</p>
                  <svg
                    className="w-6 h-6 ml-auto my-auto"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between py-2 px-6 border border-gray-400 rounded mt-4">
              <p className="text-font-gray font-semibold">Rp.136.500</p>
              <Link
                to="/checkout-success"
                className="flex items-center bg-basic-orange text-white px-4 py-2 capitalize rounded-lg"
              >
                Buat Order
                <svg
                  className="w-4 h-4 ml-6 my-auto"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 5l7 7-7 7"
                  ></path>
                </svg>
              </Link>
            </div>
            <div className="flex flex-col mt-6">
              <p>Ringkasan Belanja</p>
              <h5 className="font-semibold text-font-gray text-lg my-2 ml-4">
                Toko Blimbing
              </h5>
              <div className="flex flex-col px-4 py-2">
                <div className="flex items-start">
                  <img src={Brokoli} className="h-16 w-auto mr-4" alt="" />
                  <div className="flex flex-col">
                    <p className="text-font-gray text-lg">Brokoli</p>
                    <p className="text-font-gray text-sm opacity-75">
                      250g x 2
                    </p>
                  </div>
                  <p className="text-font-gray font-semibold ml-auto">
                    Rp 5000
                  </p>
                </div>
                <div className="flex items-start my-2">
                  <img src={JagungManis} className="h-16 w-auto mr-4" alt="" />
                  <div className="flex flex-col">
                    <p className="text-font-gray text-lg">Jagung manis</p>
                    <p className="text-font-gray text-sm opacity-75">
                      250g x 2
                    </p>
                  </div>
                  <p className="text-font-gray font-semibold ml-auto">
                    Rp 5000
                  </p>
                </div>
                <div className="flex items-start my-2">
                  <img src={Kentank} className="h-16 w-auto mr-4" alt="" />
                  <div className="flex flex-col">
                    <p className="text-font-gray text-lg">Kentang</p>
                    <p className="text-font-gray text-sm opacity-75">
                      250g x 2
                    </p>
                  </div>
                  <p className="text-font-gray font-semibold ml-auto">
                    Rp 4000
                  </p>
                </div>
                <div className="flex items-start my-2">
                  <img src={Selada} className="h-16 w-auto mr-4" alt="" />
                  <div className="flex flex-col">
                    <p className="text-font-gray text-lg">Selada</p>
                    <p className="text-font-gray text-sm opacity-75">
                      250g x 2
                    </p>
                  </div>
                  <p className="text-font-gray font-semibold ml-auto">
                    Rp 4500
                  </p>
                </div>
                <div className="flex items-start my-2">
                  <img src={PaprikaMerah} className="h-16 w-auto mr-4" alt="" />
                  <div className="flex flex-col">
                    <p className="text-font-gray text-lg">Paprika Merah</p>
                    <p className="text-font-gray text-sm opacity-75">
                      250g x 2
                    </p>
                  </div>
                  <p className="text-font-gray font-semibold ml-auto">
                    Rp 7500
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full px-4">
              <table className="table-fixed w-full mx-auto">
                <tbody>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize">
                      Subtotal
                    </td>
                    <td className="w-6/12 text-gray-600 text-sm text-right">
                      Rp 126.500
                    </td>
                  </tr>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize">
                      Ongkos Kirim
                    </td>
                    <td className="w-6/12 text-gray-600 text-sm text-right">
                      Rp 126.500
                    </td>
                  </tr>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize">
                      Total Harga
                    </td>
                    <td className="w-6/12 text-gray-600 font-semibold text-sm text-right">
                      Rp 126.500
                    </td>
                  </tr>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize pt-4">
                      Diskon
                    </td>
                    <td className="w-6/12 text-gray-600 text-sm text-right pt-4">
                      - Rp 126.500
                    </td>
                  </tr>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize">Voucher</td>
                    <td className="w-6/12 text-gray-600 text-sm text-right">
                      - Rp 126.500
                    </td>
                  </tr>
                  <tr>
                    <td className="w-6/12 text-gray-600 capitalize font-semibold">
                      Grand Total
                    </td>
                    <td className="w-6/12 text-orange-600 text-sm text-right font-semibold">
                      Rp 126.500
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </form>
      </Container>
    </LayoutHomepage>
  );
};

export default Checkout;
